// The encounter page's one status: the soft status chip (semantic tint behind semantic text), mapped in lib/visit-status.ts.
import { StatusChip } from '@scripsteam/scrips-signal-ds';
import { visitStatus } from './lib/visit-status';

export function VisitStatusChip(input: { beforeStart: boolean; providerSigned: boolean; appointmentStatus?: string | null }) {
  const status = visitStatus(input);
  if (!status) return null;
  return (
    <StatusChip data-slot="visit-status" semantic={status.semantic} tone="soft">
      {status.label}
    </StatusChip>
  );
}
